// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__2tiGj","formContainer":"login_formContainer__3M4wa","formItem":"login_formItem__2hcCQ","icon":"login_icon__1mD5A","footer":"login_footer__2tdvl"};